import React from 'react';
import classNames from 'classnames';
import { IssueStatus, IssueStatusText } from '@/utils/constant';
import './index.scss';

const IssueTypeIcon = ({ status }: { status: IssueStatus | 'urgent' }) => {
  return (
    <div
      className={classNames('issue-type-icon', {
        'short-green': status === IssueStatus.WAIT_ACCEPT,
        blue: status === IssueStatus.PROCESS,
        yellow: status === IssueStatus.ON_HOLD,
        red: status === 'urgent',
      })}
    >
      <span>{IssueStatusText.get(status)}</span>
    </div>
  );
};

export default React.memo(IssueTypeIcon);
